import React, { useCallback, useRef, useState, useEffect } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  Button,
  Hidden,
} from "@material-ui/core/";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InforWindow,
  InfoWindow,
  InfoBox,
} from "@react-google-maps/api";
import ScrollDownAppBar from "../../Components/ScrollDownAppBar/ScrollDownAppBar";
import BottomPart from "../../Components/BottomPart/BottomPart";
import ExtendCard from "../../Components/ExtendCard/ExtendCard";
import RoomData from "../../Components/ExtendCard/RoomData";
import RoomData2 from "../../Components/ExtendCard/RoomData2";
import Pagination from "../../Components/Pagination/Pagination";
import PopUpCard from "../../Components/PopUpCard/PopUpCard";
import InputInfor from "../../Components/InputInfor/InputInfor";
import WebAppBar from "../../Components/WebAppBar/WebAppBar";
import MapIcon from "@material-ui/icons/Map";
import GGMap from "../../Components/GGMap/GGMap";
import { useSelector, useDispatch } from "react-redux";
import { addPopupLatLng } from "../../Actions/RoomDataAction";
import { Link, useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
const libraries = ["places"];
function PlacePage() {
  const useStyles = makeStyles((theme) => ({
    body: {
      maxWidth: "1920px",
      margin: "0 auto",
      backgroundColor: "white",
      width: "100%",
      [theme.breakpoints.down("sm")]: { overflowX: "hidden" },
    },
    SDAppBarDiv: {
      zIndex: 100,
      position: "fixed",
      width: "100%",
      top: 0,
      left: "auto",
      right: "auto",
      color: "white",
      maxWidth: "1920px",
      margin: "0 auto",
    },
    mapButton: {
      zIndex: 100,
      position: "fixed",
      left: "50%",
      transform: "translateX(-50%)",
      bottom: 25,
      borderRadius: 50,
      boxShadow: "rgb(136, 136, 136) 0px 5px 20px 0px",
      backgroundColor: "black",
      color: "white",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    filter: {
      marginTop: "8%",
      width: "100%",
    },
    buttons: {
      marginTop: "3%",
    },
    filterButton: {
      padding: "2px 10px 5px 10px",
      borderStyle: "solid",
      borderRadius: 15,
      borderWidth: 1,
      borderColor: "black",
      display: "inline-block",
      margin: "0 2% 0 0",
      [theme.breakpoints.down("md")]: {
        marginTop: "10px",
      },
    },
    main: {
      maxWidth: "1920px",
      margin: "0 auto",
      width: "100%",
      padding: "0 3%",
      [theme.breakpoints.down("xs")]: {
        padding: "0 8%",
      },
    },
    placeList: {
      marginTop: 85,
      left: "3%",
      width: "50%",
    },
    loader:{
      margin: "40px auto 20px auto", display: "block", width:"10%"
    },
    link: {
      textDecoration: "none",
    },
    upperMap: {
      height: 85,
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    map: {
      position: "-webkit-sticky",
      position: "sticky",
      top: 85,

      width: "100%",
      maxWidth: 960,
      [theme.breakpoints.down("sm")]: {
        display: "none",
        paddingTop: 60,
      },
    },

    BottomPartDiv: {
      padding: " 30px 3%",
      backgroundColor: "#f6f5f1",
      borderWidth: "1px 0 0 0",
      borderColor: "#bbbfca",
      borderStyle: "solid",
      zIndex: 1000,
    },
  }));
  const history = useHistory();
  var x = 0;
  const openMap = () => {
    if (x % 2 === 0) {
      document.getElementById("mapButton").innerHTML = "X Đóng bản đồ";
      document.getElementById("map").style.display = "inline";
      document.getElementById("map").style.paddingTop = 60;

      const position = document.body.scrollHeight;
      console.log(position);
      document.getElementById("map").scrollIntoView();
      x = x + 1;
    } else {
      document.getElementById("mapButton").innerHTML = "O Mở bản đồ";
      document.getElementById("map").style.display = "none";
      x = x + 1;
    }
  };
  const dispatch = useDispatch();
  const roomData = useSelector((state) => state.roomData.roomList);
  const chosenPlace = useSelector((state) => state.roomData.chosenPlace);

  const [isMapButtonClicked, setMapButtonClicked] = useState(false);
  // pan map to the place had been searched

  // useRef to make react not render, useCallBack with blank Dep to make it render 1 time
  const mapRef = useRef();
  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(20);
  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  const currentPosts = roomData.slice(indexOfFirstPost, indexOfLastPost);

  function paginate(number) {
    setCurrentPage(number);
  }
  const classes = useStyles();
  const [selected, setSelected] = useState(null);

  const mapContainerStyle = {
    maxWidth: 960,
    height: "87vh",
  };

  const center = {
    // lat: 10.823099,
    // lng: 106.629662,
    lat: chosenPlace.lat,
    lng: chosenPlace.lng,
  };
  // check is ggmap loaded

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";
  setTimeout(() => {
    document.getElementById("extendCard").style.display = "block";
    document.getElementById("loader").style.display = "none";

  }, 5000);
  return (
    <div className={classes.body}>
      <div className={classes.SDAppBarDiv}>
        <ScrollDownAppBar
          pageStyle={{
            padding: "0 3% 0 3%",
            backgroundColor: "white",
            boxShadow: "0px -5px 20px 0px #888888",
          }}
          logoColor={{ color: "#fd3a69" }}
          linkColor={{ color: "#393e46" }}
          color={"#393e46"}
          panto={true}
          scrollDownAppBar={true}
        />
      </div>

      <Grid container className={classes.main}>
        <Grid
          item
          container
          xs={12}
          md={5}
          lg={6}
          className={classes.placeList}
        >
          <div style={{width:"100%"}}>
            <div className={classes.filter}>
              <div>
                <Typography>Hơn {roomData.length} chỗ ở</Typography>{" "}
                <Typography style={{ fontSize: "30px", fontWeight: "bold" }}>
                  Chỗ ở tại {currentPosts[0].cityName}
                </Typography>
              </div>
              <div className={classes.buttons}>
                <Typography className={classes.filterButton}>
                  Tùy chọn hủy linh hoạt
                </Typography>
                <Typography className={classes.filterButton}>
                  Loại nơi ở
                </Typography>
                <Typography className={classes.filterButton}>Giá</Typography>
                <Typography className={classes.filterButton}>
                  Bộ lọc khác
                </Typography>
              </div>
            </div>
            <div style={{ margin: "20px 0 0 0 " }}>
              Trang {currentPage}/{Math.ceil(roomData.length / postPerPage)}
            </div>
            <div id="loader" className={classes.loader}>
              <Loader
                type="ThreeDots"
                color="#fd3a69"
                height={"100%"}
                width={"100%"}
                timeout={5000} 
              />
            </div>
            <div id="extendCard" style={{ display: "none" }}>
              {currentPosts.map((props, index) => {
                return (
                  <Link className={classes.link} to={`/place/${props.code}`}>
                    <ExtendCard
                      key={index}
                      mainPic={props.mainPic}
                      cityName={props.cityName}
                      title={props.title}
                      maxGuestNo={props.maxGuestNo}
                      roomNo={props.roomNo}
                      bedNo={props.bedNo}
                      rate={props.rate}
                      rateNo={props.rateNo}
                      price={props.price}
                      lat={props.lat}
                      lng={props.lng}
                    />
                  </Link>
                );
              })}
            </div>
            <div
              style={{
                margin: "auto",
                alignContent: "center",
                padding: "5% 0",
              }}
            >
              <Pagination
                setScroll={0}
                paginate={paginate}
                postsPerPage={postPerPage}
                totalPosts={roomData.length}
              />
            </div>
          </div>
        </Grid>
        <Grid item container md={7} lg={6}>
          <div style={{ width: "100%", position: "relative" }}>
            <div id="map" className={classes.map}>
              <div id="upperMap" className={classes.upperMap} />
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={14}
                center={center}
                onLoad={onMapLoad}
              >
                {currentPosts.map((marker, index) => {
                  return (
                    <Marker
                      key={index}
                      position={{ lat: marker.lat, lng: marker.lng }}
                      onClick={() => {
                        setSelected(marker);
                        const action = addPopupLatLng({
                          lat: marker.lat + 0.0073,
                          lng: marker.lng,
                        });
                        dispatch(action);

                        mapRef.current.panTo({
                          lat: marker.lat,
                          lng: marker.lng,
                        });
                        mapRef.current.setZoom(14);
                      }}
                    />
                  );
                })}
                {selected ? (
                  <InfoWindow
                    position={{ lat: selected.lat, lng: selected.lng }}
                    onCloseClick={() => {
                      setSelected(null);
                      mapRef.current.setZoom(14);
                    }}
                  >
                    <div>
                      <PopUpCard
                        key={selected.key}
                        mainPic={selected.mainPic}
                        cityName={selected.cityName}
                        title={selected.title}
                        rate={selected.rate}
                        price={selected.price}
                      />
                    </div>
                  </InfoWindow>
                ) : null}
              </GoogleMap>
            </div>
          </div>
        </Grid>
      </Grid>
      {/*  */}

      <Button
        id="mapButton"
        onClick={openMap}
        variant="contained"
        className={classes.mapButton}
      >
        O Mở bản đồ
      </Button>

      {/*  */}
      <div className={classes.BottomPartDiv}>
        <BottomPart />
      </div>
    </div>
  );
}
export default PlacePage;
